import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  FDBox, FDPaper, FDProgress, FDStack,
} from '@facet-wealth/design';
import { FileViewer } from 'Components/ComponentLibrary/Components/Uncategorized/FileViewer';
import { AttachmentListItem } from 'Organisms/AttachmentsList/AttachmentListItem';
import { noop } from 'Helpers/PropTypes';
import { addQueryWithReplace } from 'Helpers/Query';
import { dataAttrs } from 'Helpers/Testing';
import fr from 'facet-rest';

export const AttachmentsList = ({
  attachments, uploading, uploadProgress, onDelete, confirmOnDelete,
}) => {
  const [viewing, setViewing] = useState(false);

  const handleView = async (attachment) => {
    const attachmentViewLink = await attachment.withRelationship(
      fr.relationships.view.name,
      (viewRel) => viewRel.link('related').url(),
      () => attachment.link('self').url(),
    );

    addQueryWithReplace({ attachmentSelfLink: attachmentViewLink });
    setViewing(true);
  };

  return (
    <FDBox>
      <FDStack direction={'column'} spacing={1}>
        {uploading ? (
          <FDPaper {...dataAttrs('file-uploading-item')}>
            <FDBox height={58} paddingX={2}>
              <FDStack height={'100%'} direction={'column'} justifyContent={'center'}>
                <FDProgress value={uploadProgress / 100} />
              </FDStack>
            </FDBox>
          </FDPaper>
        ) : null}
        {attachments.map((attachment) => (
          <AttachmentListItem
            key={attachment.id()}
            icon={'description'}
            attachment={attachment}
            onDelete={onDelete}
            onView={() => handleView(attachment)}
            confirmOnDelete={confirmOnDelete}
          />
        ))}
      </FDStack>
      <FileViewer
        eventCategory={'attachment-list-file-view'}
        attachmentResources={attachments}
        isOpen={viewing}
        closeModal={() => setViewing(false)}
      />
    </FDBox>
  );
};

AttachmentsList.defaultProps = {
  confirmOnDelete: true,
  onDelete: noop,
  uploading: false,
  uploadProgress: 0,
};

AttachmentsList.propTypes = {
  attachments: PropTypes.array.isRequired,
  onDelete: PropTypes.func,
  confirmOnDelete: PropTypes.bool,
  uploading: PropTypes.bool,
  uploadProgress: PropTypes.number,
};
